module.exports = __webpack_public_path__ + "img/exclamation-triangle.ea10af7f.svg";